<ng-container *ngIf="mortgageApplication.VendorAddress">
    <div class="form-element subtitle-section my-15">
    <p [innerHtml]="referenceDataLabels.VendorDetailsHeader|localizeLabel"></p>
    </div>
    <boi-form-text-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [fieldMaxLength]="40" [labelName]="referenceDataLabels.VendorName" [propertyNames]="['VendorAddress.Name']"
        [(value)]="mortgageApplication.VendorAddress.Name"></boi-form-text-input>
    <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.VendorTelephoneNumber" [(value)]="mortgageApplication.VendorAddress.PhoneNumber"
        [propertyNames]="['VendorAddress.PhoneNumber']" [fieldMaxLength]="20">
    </boi-form-text-input>
</ng-container>

<boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]="referenceDataOptionLists.AnswerType"
    [labelName]="referenceDataLabels.IsThisAPrivateSale" [propertyNames]="['PrivateSaleCode']"
    [(value)]="mortgageApplication.PrivateSaleCode"
    (valueChange)="mortgageApplication.InstructSurveyContactCode = null">
</boi-form-radio-button>

<ng-container *ngIf="mortgageApplication.PrivateSaleCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-text-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.WhatIsYourRelationshipToTheVen"
        [propertyNames]="['RelationshipToVendor']" [(value)]="mortgageApplication.RelationshipToVendor"
        [fieldMaxLength]="1500"></boi-form-text-input>
</ng-container>

<ng-container *ngIf="mortgageApplication.PropertySellingEstateAgentAddress && mortgageApplication.PrivateSaleCode === referenceDataOptionLists.AnswerTypeNo">
    <p class="form-element subtitle-section my-15" [innerHtml]="referenceDataLabels.EstateAgentDetailsHeader|localizeLabel"></p>
    <boi-form-text-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.EstateAgentName"
        [propertyNames]="['PropertySellingEstateAgentAddress.Name']"
        [(value)]="mortgageApplication.PropertySellingEstateAgentAddress.Name"
        [fieldMaxLength]="40"></boi-form-text-input>
    <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.EstateAgentTelephoneNumber" [(value)]="mortgageApplication.PropertySellingEstateAgentAddress.PhoneNumber"
        [propertyNames]="['PropertySellingEstateAgentAddress.PhoneNumber']" [fieldMaxLength]="20">
    </boi-form-text-input>
</ng-container>


<ng-container *ngIf="mortgageApplication.PrivateSaleCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]="referenceDataOptionLists.InstructSurveyContactTypePrivateSale"
        [labelName]="referenceDataLabels.WhoShouldWeContactToInstructTh" [propertyNames]="['InstructSurveyContactCode']"
        [(value)]="mortgageApplication.InstructSurveyContactCode" (valueChange)="setInitialContactAddressCountry()">
    </boi-form-radio-button>
</ng-container>

<ng-container *ngIf="mortgageApplication.PrivateSaleCode === referenceDataOptionLists.AnswerTypeNo">
    <boi-form-option-list [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]="referenceDataOptionLists.InstructSurveyContactTypeNotPrivateSale"
        [labelName]="referenceDataLabels.WhoShouldWeContactToInstructTh" [propertyNames]="['InstructSurveyContactCode']"
        [(value)]="mortgageApplication.InstructSurveyContactCode" (valueChange)="setInitialContactAddressCountry()">
    </boi-form-option-list>
</ng-container>


<ng-container *ngIf="mortgageApplication.PropertyAccessContactAddress && mortgageApplication.InstructSurveyContactCode === referenceDataOptionLists.RelationshipTypeOther">
    <boi-form-text-input [fieldMaxLength]="40" [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.ContactNameForAccessToProperty"
        [propertyNames]="['PropertyAccessContactAddress.Name']"
        [(value)]="mortgageApplication.PropertyAccessContactAddress.Name"></boi-form-text-input>
    <boi-form-address
        [mortgageApplication]="mortgageApplication" [(address)]="mortgageApplication.PropertyAccessContactAddress"
        [labelName]="referenceDataLabels.ContactAddressHeader" [addressLine1Required]="false"
        [propertyName]="'PropertyAccessContactAddress'" [showCountryCode]="true" [hideFindAddress]="false" [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly">
    </boi-form-address>
    <boi-form-text-input
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.ContactTelephoneNumber" [(value)]="mortgageApplication.PropertyAccessContactAddress.PhoneNumber"
        [propertyNames]="['PropertyAccessContactAddress.PhoneNumber']" [fieldMaxLength]="20">
    </boi-form-text-input>
</ng-container>
